module.exports = __webpack_public_path__ + "img/per5.3d0954fb.png";